import React from 'react';
import './About.css';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import GitHubIcon from '@mui/icons-material/GitHub';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
const About = () => {
    return(
        <div className="containerAbout">
            <div className="contTitle">
                About Us
            </div>
            <div className="bx">
                <div className="image" style={{backgroundImage:`url(${require('../images/IMG-20240102-WA0010.jpg')})`}}></div>
                <div className="name">Abdul Munaim</div>
                <div className="content">
                    Frontend.OpenCV.ML.CP

                </div>
                <div className="info">
                    <a href='https://www.linkedin.com/in/abdul-munaim-286a5a227/?originalSubdomain=np'><LinkedInIcon style={{color:'aliceblue'}} className='icons' fontSize='large'/></a>
                    <a href='https://www.instagram.com/munaim_abdul_?igsh=djh4dzFwN2oxdjl5'><InstagramIcon style={{color:'aliceblue'}} className='icons' fontSize='large'/></a>
                    <a href='https://github.com/shiningpegasus'><GitHubIcon style={{color:'aliceblue'}} className='icons' fontSize='large'/></a>
                </div>
            </div>
            <div className="bx">
                <div className="image" style={{backgroundImage:`url(${require('../images/Screenshot_20231226_171357_Photos.jpg')})`}}></div>
                <div className="name" >Aditya Raaz</div>
                <div className="content">
                {/* Passionate frontend developer crafting seamless user experiences, competitive programmer solving algorithmic puzzles, and AI enthusiast exploring innovative solutions at the intersection of tech. */}
                Frontend.CP.AI
                </div>
                <div className="info">
                    <a href='https://www.linkedin.com/in/aditya-raaz-b64a97227/?locale=es_ES'><LinkedInIcon style={{color:'aliceblue'}} className='icons' fontSize='large'/></a>
                    <a href='https://www.instagram.com/_adityaraaz__?igsh=MTZwaHpnanBlbnNzaw=='><InstagramIcon style={{color:'aliceblue'}} className='icons' fontSize='large'/></a>
                    <a href='https://github.com/Aditya-raaz01'><GitHubIcon style={{color:'aliceblue'}} className='icons' fontSize='large'/></a>
                </div>
            </div>
            <div className="bx">
                <div className="image" style={{backgroundImage:`url(${require('../images/IMG-20240102-WA0009.jpg')})`}}></div>
                <div className="name">Debasish Munda</div>
                <div className="content">
                    Frontend.Backend.ML.CP
                </div>
                <div className="info">
                    <a href='https://www.linkedin.com/in/debasish-munda-b4b0bb24b/'><LinkedInIcon style={{color:'aliceblue'}} className='icons' fontSize='large'/></a>
                    <a href='https://www.instagram.com/debashismunda/?igsh=OGV2ZmVqbTdpNWp4'><InstagramIcon style={{color:'aliceblue'}} className='icons' fontSize='large'/></a>
                    <a href='https://github.com/Demun-88?tab=repositories'><GitHubIcon style={{color:'aliceblue'}} className='icons' fontSize='large'/></a>
                </div>
            </div>
            <div className="bx">
                <div className="image" style={{backgroundImage:`url(${require('../images/IMG-20240102-WA0008.jpg')})`}}></div>
                <div className="name">Tushar Sahu</div>
                <div className="content">
                    Frontend.Backend.CP 
                </div>
                <div className="info">
                    <a href='https://www.linkedin.com/in/tushar-sahu-116a31241/'><LinkedInIcon style={{color:'aliceblue'}} className='icons' fontSize='large'/></a>
                    <a href='https://www.instagram.com/tusharsahu3676?igsh=MWMxcWxyZGtrejZ5aw=='><InstagramIcon style={{color:'aliceblue'}} className='icons' fontSize='large'/></a>
                    <a href='https://github.com/Anicrate'><GitHubIcon style={{color:'aliceblue'}} className='icons' fontSize='large'/></a>
                </div>
            </div>
            <hr className='line'></hr>
            <div className="foot">
                <div className="footHeading">
                    <div className="heading">
                        
                    </div>
                    
                </div>
                <div className="footLink">
                    <div className="footBox">
                        <a href='#' className='Link'><InstagramIcon style={{color:'aliceblue'}} className='icons' fontSize='medium'/>  Instagram</a>
                        <a href='#' className='Link'><LinkedInIcon style={{color:'aliceblue'}} className='icons' fontSize='medium'/>  LinkedIn</a>
                        <a href='#' className='Link'><TwitterIcon style={{color:'aliceblue'}} className='icons' fontSize='medium'/>  Twitter</a>
                        <a href='#' className='Link'><FacebookIcon style={{color:'aliceblue'}} className='icons' fontSize='medium'/>  Facebook</a>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default About;
